import { message } from 'antd'

/**
 * Generate sign URI, example: https://localhost:8080/api/sign/abc123
 * @param {string} id The id of the document in the app database
 */
export const createSignUri = (id) => {
  return `${process.env.REACT_APP_API}/api/sign/${id}`
}

// Copy to clipboard without using antd
export const copyLinkToClipBoard = (id) => {
  navigator.clipboard.writeText(createSignUri(id))
    .then(() => message.success('Link copied to clipboard!'))
    .catch(() => message.error('Failed to copy link to clipboard!'))
}